import SectionHeader from "../SectionHeader";
import LienWaiverTable, { LienWaiverRow } from "../LienWaiverTable";
import Card from "../Card";
import TableSkeleton from "Components/Common/Skeleton/TableSkeleton";
import Button from "Components/Common/Button/Button";

interface WaiversSectionProps {
  isActive: boolean;
  currentRows: LienWaiverRow[];
  priorRows: LienWaiverRow[];
  currentDrawNum?: number | string | null;
  onSendWaiver: (row: LienWaiverRow) => void | Promise<void>;
  onSendAllWaivers: () => void;
  sendingAll: boolean;
  loading: boolean;
}

const WaiversSection = ({
  isActive,
  currentRows,
  priorRows,
  currentDrawNum,
  onSendWaiver,
  onSendAllWaivers,
  sendingAll,
  loading,
}: WaiversSectionProps) => {
  const drawLabel = currentDrawNum ? `#${currentDrawNum}` : "";

  return (
    <div className={`section ${isActive ? "active" : ""}`} id="sec-waivers">
      <SectionHeader
        title="Lien Waivers"
        subtitle="Collect and track lien waivers from all subcontractors and suppliers. Waivers are required for vendors paid $5,000 or more per draw."
      />

      {loading ? (
        <TableSkeleton cols={5} rows={4} />
      ) : (
        <>
          {/* {pendingCount > 0 && (
            <BlockerAlert
              icon="🔒"
              title={`Draw ${drawLabel} Funds Blocked — ${pendingCount} Waiver${pendingCount !== 1 ? "s" : ""} Outstanding`}
              text={`TD Bank cannot release Draw ${drawLabel} funds until all required lien waivers are received. Send reminders to outstanding subcontractors below.`}
            />
          )} */}
          <Card
            title={`Draw ${drawLabel} — Current Draw Waivers`}
            action={
              <Button
                className="btn teal sm mb-3"
                onClick={onSendAllWaivers}
                disabled={sendingAll}
              >
                {sendingAll ? "Sending..." : "Send All Reminders"}
              </Button>
            }
          >
            <LienWaiverTable
              rows={currentRows}
              showActions
              onSubmit={onSendWaiver}
            />
          </Card>
          {priorRows.length > 0 && (
            <Card
              title="Prior Draws — All Waivers Complete"
              className="lienTableCard"
            >
              <LienWaiverTable rows={priorRows} />
            </Card>
          )}
        </>
      )}
    </div>
  );
};

export default WaiversSection;
